// removed by extract-text-webpack-plugin
module.exports = {"mainContainer":"_1IdZbbetApEt3i67pxleDO","photo":"_3hcKvumcVuMxFawAzmdizd","infoContainer":"_1xWvGxo5y2HS107PVKc6kb","username":"bnSHks-V0tjGuOpgIJtES","logout":"_1AAyhvFpYa1OjHF9SCljFa","changeTheme":"_2kszOrUI599hoE9dfeixRu","mainContainerDarkTheme":"_2J3OB464JiioHFkkqQLvPC"};


//////////////////
// WEBPACK FOOTER
// ./src/pages/chat/conversations/user-card-logged/UserCardLogged.css
// module id = 255
// module chunks = 0